/**
 * Client Company Mappings Configuration
 * 
 * This file contains the mapping between client IDs and company information
 * for the message system. In a production environment, this data should
 * ideally be fetched from an API endpoint.
 */

export interface ClientCompanyMapping {
  clientId: string;
  companyId: string;
  companyName: string;
}

export const DEFAULT_ITEM: ClientCompanyMapping = { 
  clientId: '', 
  companyId: '', 
  companyName: 'Select company...' 
};

export const CLIENT_COMPANY_MAPPINGS: ClientCompanyMapping[] = [
  DEFAULT_ITEM,   

/*
  COMPANYID	COMPANYNAME		CLIENTID
  1736451491	BUYEFFICIENT SUPER ADMIN	1736451490
  1736451491	BUYEFFICIENT SUPER ADMIN	4352559136
  1736451491	BUYEFFICIENT SUPER ADMIN	4357710318
  1736451491	BUYEFFICIENT SUPER ADMIN	4368645992

  CLIENTID	  COMPANYNAME	                  COMPANYID
  3944446589	Peoria Bickford Cottage ~	    3941820937
  4104671867	The Grande Colonial Hotel	    4099724294


*/
{ clientId: '3944446589', companyId: '3941820937', companyName: 'Peoria Bickford Cottage ~' },
{ clientId: '4104671867', companyId: '4099724294', companyName: 'The Grande Colonial Hotel' },


  { clientId: '1736451490', companyId: '1736451491', companyName: 'BUYEFFICIENT SUPER ADMIN cid ends in 1490' },
  { clientId: '4352559136', companyId: '1736451491', companyName: 'BUYEFFICIENT SUPER ADMIN cid ends in 9136' },
  { clientId: '4357710318', companyId: '1736451491', companyName: 'BUYEFFICIENT SUPER ADMIN cid ends in 0318' },
  { clientId: '4368645992', companyId: '1736451491', companyName: 'BUYEFFICIENT SUPER ADMIN cid ends in 5992' }, 
  //----------------------------------------------------------------------------------------
  { clientId: '4093191805', companyId: '4349005535', companyName: 'Crystal Lake Bickford Cottage  ***has Out & Inbox attachments***' },
  // NOTE: clientId for Crystal Lake Bickford Cottage was 1748229520 should be 4093191805
  { clientId: '1732875179', companyId: '1732875180', companyName: 'PPRO TEST OLD ***has Outbox attachments***' },  
  // { clientId: '1748229520', companyId: '2444615304', companyName: 'Supply America OLD (same clientid as Crystal Lake Bickford Cottage; diff. companyid)' },
  //----------------------------------------------------------------------------------------
  { clientId: '4599386644', companyId: '4599386645', companyName: 'The Industrialist Hotel, Pittsburgh, Autograph Collection' },
  { clientId: '4338799446', companyId: '3955674034', companyName: 'Advantage Fitness Products' },
  { clientId: '4542172039', companyId: '4542172040', companyName: 'Aloft Denver Downtown' },
  { clientId: '3995864447', companyId: '2444614416', companyName: 'Ames Bickford Cottage' },
  { clientId: '4716126544', companyId: '4716126545', companyName: 'Anchor Inn' },
  { clientId: '1745162568', companyId: '2444614352', companyName: 'Arcade Industries, Inc.' },
  { clientId: '4868901829', companyId: '4673847617', companyName: 'Ascent Hospitality, LLC' }, 
  { clientId: '4426576696', companyId: '4426516643', companyName: 'Best Western Inn & Suites San Diego - Zoo/SeaWorld Area' },
  { clientId: '4632753472', companyId: '4623180106', companyName: 'Best Western Naples Inn & Suites' }, 
  // { clientId: '4509129531', companyId: '4678000670', companyName: 'Best Western Plus Arroyo Roble Hotel & Creekside Villas' },  //over 433,000 records
  { clientId: '4836293287', companyId: '4836293288', companyName: 'CMI - Holiday Inn Downtown Chicago - Voco Chicago Downtown' }, 
  { clientId: '4907704527', companyId: '4917203902', companyName: 'CNA (fka Clark Pro) -  Avendra' }, 
  { clientId: '4349090448', companyId: '4093191812', companyName: 'Concordia Senior Living' },  
  { clientId: '1762410392', companyId: '1761892894', companyName: 'Courtyard Lyndhurst OLD' }, 
  { clientId: '1747235882', companyId: '1746713308', companyName: 'Courtyard Salt Lake City OLD' }, 
  { clientId: '2023938729', companyId: '2023284317', companyName: 'CYPRESS HOTEL OLD' }, 
  { clientId: '4725703644', companyId: '4725703645', companyName: 'DoubleTree by Hilton San Francisco South Airport Blvd' },
  { clientId: '4377296163', companyId: '4375485679', companyName: 'Element Omaha OLD' },
  { clientId: '1766341225', companyId: '1766210704', companyName: 'Embassy Suites Chicago OLD' },  
  // NOTE: clientId for Embassy Suites Chicago was 1748290065 should be 1766210704
  { clientId: '1748290065', companyId: '2200157482', companyName: 'Erwyn Group - BE' },
  { clientId: '4626113118', companyId: '4626113119', companyName: 'Ensemble Hotel Partners LLC' }, 
  { clientId: '1622607701', companyId: '1736337300', companyName: 'Hampton Inn Vanderbilt OLD' },
  { clientId: '1735952744', companyId: '1735952745', companyName: 'HOLIDAY INN & SUITES MESA OLD' },
  { clientId: '43661', companyId: '1735854051', companyName: 'HOLIDAY INN EXPRESS OLD TOWN OLD' },  
  { clientId: '3973457071', companyId: '3973457072', companyName: 'JC Produce OLD' },
  { clientId: '4252141907', companyId: '4213331983', companyName: 'NYLO Providence - Warwick OLD' }, 
  { clientId: '4344943139', companyId: '4342386975', companyName: 'Rancho Las Palmas OLD' },
  /*  clientId (from iBAU):  4533069103
      companyId (from iBAU): 4533069104 
*/
  { clientId: '4533069103', companyId: '4533069104', companyName: 'AVENDRA DEMO EAST REGION' }, 
  //clientId WAS 4533069103 also Avendra Demo East Region, contact Avendra Demo Region; clientid 4533095645 contact Vice President
  // clientid is 4533069103   companyid is 4533069104   companyname AVENDRA DEMO EAST REGION
  
  { clientId: '4515753892', companyId: '4515753893', companyName: 'AVENDRA DEMO FULL SERVICE' }, 

  //clientId 4533069538   companyId 4533069539
  { clientId: '4533069538', companyId: '4533069539', companyName: 'AVENDRA DEMO INDEPENDENT' },  //was clientId 4533070571

  { clientId: '4533070333', companyId: '4514165225', companyName: 'AVENDRA SUPER ADMIN' },
  { clientId: '4607727072', companyId: '4515751893', companyName: 'AVENDRA SUPPLIER DEMO COMPANY' },  
  { clientId: '4629399958', companyId: '4605120646', companyName: '700 TownePlace Suites Dallas Plano South' },
  { clientId: '4758640469', companyId: '4669995159', companyName: '706 Home2 Suites Tucson Airport' },
  { clientId: '4796284507', companyId: '4781483691', companyName: '708 Home2 Suites Davenport Orlando' },
  { clientId: '4416448759', companyId: '4412117843', companyName: '889 Residence Inn Houston I-10 West-Park Row' }, 
];

/**
 * Validates a client company mapping object
 */
export const validateClientMapping = (mapping: any): mapping is ClientCompanyMapping => {
  return (
    mapping &&
    typeof mapping === 'object' &&
    typeof mapping.clientId === 'string' &&
    typeof mapping.companyId === 'string' &&
    typeof mapping.companyName === 'string'
  );
};

/**
 * Finds a mapping by client ID with validation
 */
export const findMappingByClientId = (clientId: string): ClientCompanyMapping | undefined => {
  return CLIENT_COMPANY_MAPPINGS.find(mapping => mapping.clientId === clientId);
};

/**
 * Gets all valid client IDs (excluding empty default)
 */
export const getValidClientIds = (): string[] => {
  return CLIENT_COMPANY_MAPPINGS
    .filter(mapping => mapping.clientId !== '')
    .map(mapping => mapping.clientId);
};